export enum ReviewStatus {
  Submitted = 'Submitted',
  Published = 'Published',
  Curated = 'Curated',
}
